import type { FC, PropsWithChildren, ReactNode } from 'react';

import type { FeatureFlagNames } from 'api/configuration/features/FeatureFlagConfigurationSetting';
import { useFeatureFlag } from 'api/configuration/features/hooks/useFeatureFlag';

export interface WhenFeatureIsEnabledProps {
  featureName: FeatureFlagNames;
  disabled?: ReactNode;
}

export const WhenFeatureIsEnabled: FC<PropsWithChildren<WhenFeatureIsEnabledProps>> = ({
  featureName,
  children,
  disabled
}) => {
  const show = useFeatureFlag(featureName);

  return (
    <>
      {show && children}
      <>{disabled !== undefined && !show && disabled}</>
    </>
  );
};
